import IMAGES from "./images.json";

/* <img> with AVIF/WebP sources from public/images/opt/ (scripts/optimize-images.js)
   and intrinsic width/height so the browser reserves space before it loads.
   Images not listed in src/images.json render as a plain <img>.
   Below-the-fold images are lazy by default; pass loading="eager" (and
   fetchPriority="high" for the LCP image) above the fold. */
export default function Picture({ src, alt, sizes, loading = "lazy", ...rest }) {
  const key = src.replace(/^\/images\//, "");
  const meta = IMAGES[key];
  const img = (
    <img
      src={src}
      alt={alt}
      width={meta ? meta.width : undefined}
      height={meta ? meta.height : undefined}
      loading={loading}
      decoding="async"
      {...rest}
    />
  );
  if (!meta) return img;

  const base = `/images/opt/${key.replace(/\.[a-z]+$/i, "")}`;
  const srcSet = (ext) => meta.widths.map((w) => `${base}-${w}.${ext} ${w}w`).join(", ");
  return (
    <picture>
      <source type="image/avif" srcSet={srcSet("avif")} sizes={sizes} />
      <source type="image/webp" srcSet={srcSet("webp")} sizes={sizes} />
      {img}
    </picture>
  );
}
